<template>
  <div class="info-page">
    <crumbs title="企业评价得分自评" />
    <div
      v-for="(question, qi) in questionList"
      :key="qi"
      class="info-page__item"
    >
      <div class="info-page__title">
        <span>{{ question.name }}</span>
      </div>
      <el-form
        :model="question.form"
        ref="ruleForm"
        label-position="right"
        label-width="auto"
      >
        <el-row
          :gutter="10"
          v-for="(item, index) in question.form.dataList"
          :key="index"
        >
          <el-col :span="24">
            <template v-if="item.isCheckbox">
              <el-form-item :prop="'dataList.' + index + '.answer'">
                <div class="row-title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="row-content">
                  <el-checkbox-group :value="item.answer">
                    <el-checkbox
                      v-for="(op, i) in item.option"
                      :key="i"
                      :label="op"
                      :class="{
                        line: item.isBlock
                      }"
                    ></el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item :prop="'dataList.' + index + '.answer'">
                <div class="row-title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="row-content">
                  <el-radio-group :value="item.answer">
                    <el-radio
                      v-for="(op, i) in item.option"
                      :key="i"
                      :label="op.value"
                      :class="{
                        line: item.isBlock
                      }"
                      >{{ op.name }}</el-radio
                    >
                  </el-radio-group>
                </div>
              </el-form-item>
            </template>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "qualificationEvaluateScore",
  data() {
    return {
      questionList: [
        {
          name: "（一）专业化指标",
          form: {
            dataList: [
              {
                title: "1.上年度主营业务收入总额占营业收入总额比重",
                answer: "",
                option: [
                  {
                    name: "60%以下",
                    value: 0
                  },
                  {
                    name: "60%-70%",
                    value: 1
                  },
                  {
                    name: "70%-80%",
                    value: 3
                  },
                  {
                    name: "80%以上",
                    value: 5
                  }
                ]
              },
              {
                title: "2.近2年主营业务收入平均增长率",
                answer: "",
                option: [
                  {
                    name: "0%以下",
                    value: 0
                  },
                  {
                    name: "0%-4%",
                    value: 2
                  },
                  {
                    name: "4%-6%",
                    value: 4
                  },
                  {
                    name: "6%-8%",
                    value: 6
                  },
                  {
                    name: "8%-10%",
                    value: 8
                  },
                  {
                    name: "10%以上",
                    value: 10
                  }
                ]
              },
              {
                title: "3.从事特定细分市场年限",
                answer: "",
                option: [
                  {
                    name: "未满2年",
                    value: 0
                  },
                  {
                    name: "2年-3年",
                    value: 1
                  },
                  {
                    name: "4年-5年",
                    value: 2
                  },
                  {
                    name: "6年-7年",
                    value: 3
                  },
                  {
                    name: "8年-9年",
                    value: 4
                  },
                  {
                    name: "10年及以上",
                    value: 5
                  }
                ]
              },
              {
                title: "4.主导产品所属领域情况",
                answer: "",
                isBlock: true,
                option: [
                  {
                    name: "在产业链供应链关键环节及关键领域“补短板”“锻长板”“填空白”取得实际成效",
                    value: 5
                  },
                  {
                    name: "属于工业“六基”领域、中华老字号名录或企业主导产品服务关键产业链重点龙头企业",
                    value: 3
                  },
                  {
                    name: "不属于以上情况",
                    value: 0
                  }
                ]
              }
            ]
          }
        },
        {
          name: "（二）精细化指标",
          form: {
            dataList: [
              {
                title: "5.数字化水平",
                answer: "",
                option: [
                  {
                    name: "一级",
                    value: 0
                  },
                  {
                    name: "二级",
                    value: 3
                  },
                  {
                    name: "三级以上",
                    value: 5
                  }
                ]
              },
              {
                title: "6.质量管理水平（如不满足以下条件，该题可跳过）",
                answer: [],
                isBlock: true,
                isCheckbox: true,
                option: [
                  "获得省级以上质量奖荣誉（“鲁班奖”“国家优质工程奖”）",
                  "建立质量管理体系，获得ISO9001等质量管理体系认证证书",
                  "拥有自主品牌（商标）",
                  "参与制修订标准"
                ]
              },
              {
                title: "7.上年度净利润率",
                answer: "",
                option: [
                  {
                    name: "2%以下",
                    value: 0
                  },
                  {
                    name: "2%-4%",
                    value: 2
                  },
                  {
                    name: "4%-6%",
                    value: 4
                  },
                  {
                    name: "6%-8%",
                    value: 6
                  },
                  {
                    name: "8%-10%",
                    value: 8
                  },
                  {
                    name: "10%以上",
                    value: 10
                  }
                ]
              },
              {
                title: "8.上年度资产负债率",
                answer: "",
                option: [
                  {
                    name: "50%以下",
                    value: 5
                  },
                  {
                    name: "50%-60%",
                    value: 3
                  },
                  {
                    name: "60%-70%",
                    value: 1
                  },
                  {
                    name: "70%以上",
                    value: 0
                  }
                ]
              }
            ]
          }
        },
        {
          name: "（三）特色化指标",
          form: {
            dataList: [
              {
                title: "9.企业上市挂牌情况",
                answer: "",
                isBlock: true,
                option: [
                  {
                    name: "企业已上市（不含全国股转系统挂牌）",
                    value: 9
                  },
                  {
                    name: "企业上市申请已获得证监会、交易所受理或者已到北京证监局申报辅导备案（需提供证明文件）",
                    value: 7
                  },
                  {
                    name: "企业已在全国股转系统挂牌或者已提交挂牌申请并获得全国股转系统受理（需提供证明文件）",
                    value: 5
                  },
                  {
                    name: "企业已启动上市、挂牌工作并已签约保荐机构或者挂牌券商（需提供证明文件）",
                    value: 3
                  },
                  {
                    name: "不符合上述情况",
                    value: 0
                  }
                ]
              },
              {
                title: "10.企业为北京市产业链龙头企业配套情况",
                answer: "",
                isBlock: true,
                option: [
                  {
                    name: "企业属于北京市高精尖产业领域，且企业主导产品服务北京市产业链龙头企业",
                    value: 3
                  },
                  {
                    name: "不属于以上情况",
                    value: 0
                  }
                ]
              },
              {
                title: "11.企业创新技术研发转化及海外市场拓展情况",
                answer: "",
                isBlock: true,
                option: [
                  {
                    name: "企业近三年获得首台套产品认定（没有上传认定证明），新技术新产品认定(含二类、三类医疗器械临床批件和批准文号，在研创新药、改良型新药和生物类似药II期、III期临床批件和药品批准文号)1项以上",
                    value: 3.1
                  },
                  {
                    name: "企业获得“首台套”“首批次”“首流片”等应用政策支持",
                    value: 3.2
                  },
                  {
                    name: "产品通过发达国家和地区产品认证（国际标准协会行业认证）1项以上",
                    value: 3.3
                  },
                  {
                    name: "不符合上述情况",
                    value: 0
                  }
                ]
              }
            ]
          }
        },
        {
          name: "（四）创新能力指标",
          form: {
            dataList: [
              {
                title: "12.与企业主导产品相关的有效知识产权数量",
                answer: "",
                option: [
                  {
                    name: "I类高价值知识产权1项以上",
                    value: 10
                  },
                  {
                    name: "自主研发I类知识产权1项以上",
                    value: 8
                  },
                  {
                    name: "I类知识产权1项以上",
                    value: 6
                  },
                  {
                    name: "II类知识产权1项以上",
                    value: 2
                  },
                  {
                    name: "无",
                    value: 0
                  }
                ]
              },
              {
                title: "13.上年度研发费用投入",
                answer: "",
                isBlock: true,
                option: [
                  {
                    name: "研发费用总额500万元以上或研发费用总额占营业收入总额比重在10%以上",
                    value: 10
                  },
                  {
                    name: "研发费用总额400-500万元或研发费用总额占营业收入总额比重在8%-10%",
                    value: 8
                  },
                  {
                    name: "研发费用总额300-400万元或研发费用总额占营业收入总额比重在6%-8%",
                    value: 6
                  },
                  {
                    name: "研发费用总额200-300万元或研发费用总额占营业收入总额比重在4%-6%",
                    value: 4
                  },
                  {
                    name: "研发费用总额100-200万元或研发费用总额占营业收入总额比重在3%-4%",
                    value: 2
                  },
                  {
                    name: "不属于以上情况",
                    value: 0
                  }
                ]
              },
              {
                title: "14.上年度研发人员占比",
                answer: "",
                option: [
                  {
                    name: "5%以下",
                    value: 0
                  },
                  {
                    name: "5%-10%",
                    value: 1
                  },
                  {
                    name: "10%-20%",
                    value: 3
                  },
                  {
                    name: "20%以上",
                    value: 5
                  }
                ]
              },
              {
                title: "15.建立研发机构级别",
                answer: "",
                option: [
                  {
                    name: "国家级",
                    value: 10
                  },
                  {
                    name: "省级",
                    value: 8
                  },
                  {
                    name: "市级",
                    value: 4
                  },
                  {
                    name: "市级以下",
                    value: 2
                  },
                  {
                    name: "未建立研发机构",
                    value: 0
                  }
                ]
              }
            ]
          }
        }
      ]
    };
  },
  created() {
    this.loadInfo();
  },
  methods: {
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      let idx = 0;
      this.questionList.map((qs) => {
        qs.form.dataList.map((item) => {
          item.answer = data[idx];
          idx++;
        });
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("service", "getQualificationScoreCountInfo", { id }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.downloadProcessData(JSON.parse(res.dataList));
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  .info-page__item {
    /deep/ .el-form {
      padding-left: 68px;
      .row-title {
        display: flex;
        padding: 11px 0;
        line-height: 24px;
        font-size: 16px;
      }
      .row-content {
        padding-left: 16px;
      }
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__content {
          .el-radio-group {
            .el-radio {
              padding: 0;
              margin-right: 50px;
              line-height: 46px;
              font-size: 16px;
              white-space: pre-wrap;
              &.line {
                display: block;
                margin-right: 0;
              }
            }
          }
          .el-checkbox-group {
            .el-checkbox {
              padding: 0;
              margin-right: 50px;
              line-height: 46px;
              font-size: 16px;
              white-space: pre-wrap;
              &.line {
                display: block;
                margin-right: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
